export const customerRole = {
    supplier: 'supplier',
    producer: 'producer',
    logistics: 'logistics',
    distributor: 'distributor',
    reseller: 'reseller',
    discounter: 'discounter',
};
